// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-report__tooltip{display:unset!important}", "",{"version":3,"sources":["webpack://app/containers/disputes/actions/report/style.css"],"names":[],"mappings":"AACE,wBACE,uBACF","sourcesContent":[".action-report {\n  &__tooltip {\n    display: unset !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
